import React, { memo, useState } from "react";
import { FixedSizeList, areEqual } from "react-window";
import { ListItem } from "@material-ui/core";
import moment from "moment-timezone";
const renderRow = memo(({ data, index, style }) => {
  const item = data.settlements[index];
  return (
    <>
      <ListItem
        button
        style={style}
        key={index}
      >
        <>
          <div className='card horizontal' style={{ width: "100%" }}>
            <div className='card-stacked'>
              <div className='card-content'>
                <span className='card-title'>
                  <h6>Trip # {item.id} / {moment.tz(item.tripDate, "America/Chicago").format("YYYY-MM-DD")}</h6>
                </span>
                <p>
                  {item.standardRateName}
                  <br />
                  Ticket # {item.ticketConsigneeNumber}
                  <br />
                  Tons: {item.consigneeTons}
                  <br />
                  {!item.hasDocuments && !item.audited ? (
                    <span className='new badge red' data-badge-caption='No documents'></span>
                  ) : item.hasDocuments && !item.audited ? (
                    <span className='new badge orange' data-badge-caption='Pending Audit'></span>
                  ) : (
                    <span className='new badge green' data-badge-caption='Audited'></span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </>
      </ListItem>
    </>
  );
}, areEqual);

export default function ListSettlements(props) {
  const { settlements } = props;
  const heigth = window.innerHeight - 100;
  const width = window.innerWidth;

  return (
    <>
      {settlements && (
        <>
          <FixedSizeList
            height={heigth}
            width={width}
            itemSize={195}
            itemCount={settlements.length}
            itemData={{
              settlements
            }}
          >
            {renderRow}
          </FixedSizeList>
        </>
      )}
    </>
  );
}
